 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~db314e9e":"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~db314e9e","account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~59e2d741":"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~59e2d741","account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~1226afe7":"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~1226afe7","account~login~settings-analysis~settings-data-import~settings-user":"account~login~settings-analysis~settings-data-import~settings-user","account":"account","settings-user":"settings-user","book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse~ea6376db":"book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse~ea6376db","book-import":"book-import","browse-book":"browse-book","browse-collection":"browse-collection","browse-collections":"browse-collections","browse-libraries":"browse-libraries","browse-readlist":"browse-readlist","browse-readlists":"browse-readlists","browse-series":"browse-series","dashboard":"dashboard","home":"home","read-book":"read-book","search":"search","settings-users":"settings-users","settings-server":"settings-server","login":"login","settings-analysis":"settings-analysis","settings-data-import":"settings-data-import","notfound":"notfound","settings":"settings","welcome":"welcome","startup":"startup"}[chunkId]||chunkId) + "." + {"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~db314e9e":"9b6d71c1","account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~59e2d741":"e99393f6","account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~1226afe7":"597260d7","account~login~settings-analysis~settings-data-import~settings-user":"b7033e3c","account":"8d8280db","settings-user":"9b0ad237","book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse~ea6376db":"ab84149e","book-import":"6e7677ca","browse-book":"f7658ecc","browse-collection":"bc178d73","browse-collections":"c4c723bb","browse-libraries":"fa51a17a","browse-readlist":"c4b2dccc","browse-readlists":"be1dd729","browse-series":"c1661d9e","dashboard":"28209905","home":"cdf5857e","read-book":"f0e71727","search":"9276419c","settings-users":"387ef4d0","settings-server":"c11bb386","login":"cb5a171a","settings-analysis":"9780e194","settings-data-import":"bfb425b0","notfound":"53f568c7","settings":"012526ed","welcome":"ad6e5aac","startup":"27c5b674"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~db314e9e":1,"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~59e2d741":1,"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~1226afe7":1,"account~login~settings-analysis~settings-data-import~settings-user":1,"account":1,"settings-user":1,"book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse~ea6376db":1,"book-import":1,"browse-book":1,"browse-collection":1,"browse-collections":1,"browse-libraries":1,"browse-readlist":1,"browse-readlists":1,"browse-series":1,"dashboard":1,"home":1,"read-book":1,"search":1,"settings-users":1,"settings-server":1,"login":1,"settings-analysis":1,"settings-data-import":1,"notfound":1,"settings":1,"welcome":1,"startup":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~db314e9e":"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~db314e9e","account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~59e2d741":"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~59e2d741","account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~1226afe7":"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~1226afe7","account~login~settings-analysis~settings-data-import~settings-user":"account~login~settings-analysis~settings-data-import~settings-user","account":"account","settings-user":"settings-user","book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse~ea6376db":"book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse~ea6376db","book-import":"book-import","browse-book":"browse-book","browse-collection":"browse-collection","browse-collections":"browse-collections","browse-libraries":"browse-libraries","browse-readlist":"browse-readlist","browse-readlists":"browse-readlists","browse-series":"browse-series","dashboard":"dashboard","home":"home","read-book":"read-book","search":"search","settings-users":"settings-users","settings-server":"settings-server","login":"login","settings-analysis":"settings-analysis","settings-data-import":"settings-data-import","notfound":"notfound","settings":"settings","welcome":"welcome","startup":"startup"}[chunkId]||chunkId) + "." + {"account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~db314e9e":"f62fc052","account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~59e2d741":"32e4474a","account~book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlis~1226afe7":"0387ac7f","account~login~settings-analysis~settings-data-import~settings-user":"a2378f9f","account":"50d8ff85","settings-user":"7093485c","book-import~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse~ea6376db":"c578333e","book-import":"581920f8","browse-book":"7dc51a62","browse-collection":"112773ba","browse-collections":"ebea79b6","browse-libraries":"1ccd4ffd","browse-readlist":"d0dfc645","browse-readlists":"ebea79b6","browse-series":"4e3529c7","dashboard":"8105208b","home":"1e934cd6","read-book":"768a543d","search":"938db012","settings-users":"55ae616a","settings-server":"5a7620a7","login":"7c1919bb","settings-analysis":"609b9a3f","settings-data-import":"d2cf129e","notfound":"45eb3198","settings":"171bc8fa","welcome":"7cc5818c","startup":"7cc5818c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
